import React from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './components/ScrollToTop';
import NavigationLayout from './layouts/NavigationLayout';

// Public Pages
import HomeLanding from './pages/home-landing';
import SmartBookingForm from './pages/smart-booking-form';
import LanguageSelection from './pages/language-selection';

// Admin (hidden)
import AdminLogin from './pages/admin-login';

// 404
import NotFound from './pages/NotFound';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          <Route path="/" element={<NavigationLayout><HomeLanding /></NavigationLayout>} />
          <Route path="/home-landing" element={<NavigationLayout><HomeLanding /></NavigationLayout>} />
          <Route path="/smart-booking-form" element={<NavigationLayout><SmartBookingForm /></NavigationLayout>} />
          <Route path="/language-selection" element={<NavigationLayout><LanguageSelection /></NavigationLayout>} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;